<ng-container>
  <div class="justify-content-end d-md-flex d-lg-flex d-xl-flex" *hideIfApp>
    @if (changeLayoutModeActive) {
      <button class="btn btn-success btn-sm mb-2 me-2" [disabled]="!widgetsLoaded()" (click)="addWidgetDialog()">
        <em class="fas fa-plus px-1"></em>
        <span>{{ 'Widget hinzufügen' | translate }}</span>
      </button>
    }

    @if (!changeLayoutModeActive){
      <button class="btn btn-outline-dark btn-sm mb-2" (click)="changeLayoutMode()">
        <em class="fas fa-table-cells px-1"></em>
        <span>{{ 'Layout ändern' | translate }}</span>
      </button>
    } @else {
      <button class="btn btn-outline-dark btn-sm mb-2" (click)="changeLayoutMode()">
        <em class="fas fa-square-check px-1"></em>
        <span>{{ 'Layout akzeptieren' | translate }}</span>
      </button>
    }
  </div>
  @if (!showMessage) {
    <div class="row" cdkDropListGroup>
      @for (container of widgetsMatrix; track container; let i = $index) {
        <div
          class="col-xl-4 col-lg-4 col-md-6 col-12 widget-item"
          >
          <div
            cdkDropList
            class="ngx-dnd-container"
            [ngClass]="{ 'ngx-dnd-container-highlight ': changeLayoutModeActive }"
            [cdkDropListData]="container"
            #dndContainer="cdkDropList"
            [cdkDropListDisabled]="!changeLayoutModeActive"
            (cdkDropListDropped)="onDrop($event)"
            [cdkDropListConnectedTo]="[dndContainer]"
            >
            @for (item of container; track item) {
              <div
                class="p-1 position-relative widget-overview__item"
                #listItems
                    [ngClass]="{
                        hoverable: changeLayoutModeActive,
                        'cursor-pointer': changeLayoutModeActive,
                        'cursor-auto': !changeLayoutModeActive,
                        'active-layout-widget': changeLayoutModeActive,
                        'mobile-widget': item?.visibilityType === 'Mobile only',
                        'debug-mode-active': debugModeStatus,
                    }"
                cdkDrag
                (cdkDragStarted)="isDragging = true"
                (cdkDragEnded)="isDragging = false"
                >
                <ng-container *cdkDragPlaceholder>
                  <div class="empty-widget-placeholder"></div>
                </ng-container>
                @if (changeLayoutModeActive) {
                  <em
                    class="fas fa-trash text-danger widget-icon"
                    (click)="deleteWidgetById(item?.id)"
                  ></em>
                }
                @if (changeLayoutModeActive && item?.visibilityType === 'Mobile only') {
                  <em class="fas fa-mobile widget-icon widget-icon--mobile"></em>
                }
                <ng-container *ngComponentOutlet="item?.component"></ng-container>
              </div>
            }
            @if (changeLayoutModeActive && !isDragging) {
              <div class="column-widget-add" (click)="addWidgetDialog(i)">
                <div class="column-widget-add__icon-wrapper">
                  <em class="column-widget-add__icon fas fa-plus"></em>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</ng-container>
